import { BodyCellWithId } from "types/business/BodyCellWithId";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = BodyCellWithId[];

export const useDefaultObservableBodyCellWithIdArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectBodyCellWithIdArray extends BehaviorSubject<CurrentType> {}
